export const parseSearchString = ( string ) => {
	if ( string === '' )
	{
		return {};
	}

	return JSON.parse( '{"' + string.slice( 1 ).replace( /&/g, '","' ).replace( /=/g, '":"' ) + '"}' );
};